import { observer } from 'mobx-react';
import { Success } from '../../../../EditGroupStore/Types';
import { T } from '../../../../Translations';
import GroupSuccessModal from '../Shared/GroupSuccessModal';

interface Props {
  state: Success;
  onAddParticipants: () => void;
  onClose: () => void;
  returnUrl: string;
}

function EditGroupSuccessModal({ state, onAddParticipants, onClose, returnUrl }: Props) {
  // Determine if returning to a specific group page or the groups list
  const isReturningToSpecificGroup = /^\/people\/groups\/\d+$/.test(returnUrl);
  const backButtonText = isReturningToSpecificGroup ? 'Back to Group' : 'Return to Groups List';

  return (
    <GroupSuccessModal
      heading={<T kind="Group Edited" />}
      name={state.name}
      licenseCount={state.licenseCount}
      collectionCount={state.collectionCount}
      onClose={onClose}
    >
      <button
        className="w-full py-2.5 px-4 rounded-lg bg-accent text-accent-foreground hover:opacity-90 transition-opacity"
        style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-semibold)' }}
        onClick={onAddParticipants}
        data-intercom-target="edit-group-success-add-participants-button"
      >
        <T kind="Add Participants to this Group" />
      </button>
      <button
        className="w-full py-2 text-muted-foreground hover:text-foreground transition-colors"
        style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
        onClick={onClose}
        data-test-close-button="true"
        data-intercom-target="edit-group-success-back-button"
      >
        <T kind={backButtonText} />
      </button>
    </GroupSuccessModal>
  );
}

export default observer(EditGroupSuccessModal);
